module.exports = __webpack_public_path__ + "img/bu-line.56067562.svg";